import React from "react";
import { useState, useEffect } from "react";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import {
  getData,
  getComplianceData,
  setComplianceData,
  runMMCompliance,
  runMMComplReport,
  runMMComplSpreads,
} from "../../../services/user.service";

import { useLocation } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import moment from "moment/moment";
import "moment/locale/es";
import { COLUMN_GROUPING_MODEL, MI_COLUMNS } from "../../../utils/constants";
import { compByProduct, monthsByMM } from "../../../utils/helpers";
import Button from "../../../components/button";
import LinkedDropdowns from "./linked-dropdowns";
import styles from "./styles.module.css";
moment.locale("es");

registerLocale("es", es);

const theme = createTheme({
  palette: {
    mode: "light",
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
        },
        columnHeader: {
          backgroundColor: "hsl(var(--secondary))",
          color: "hsl(var(--muted-foreground))",
          fontWeight: 600,
        },
        columnHeaderTitle: {
          fontWeight: 600,
          color: "hsl(var(--muted-foreground))",
        },
      },
    },
  },
});

function ComplianceReport() {
  const [mmdata, setMMdata] = useState(new Map());
  const [comData, setComData] = useState(new Map());
  const [editedComData, setEditComData] = useState(new Map());
  const [origComData, setOrigComData] = useState(new Map());
  const [updating, setUpdating] = useState("");
  const [selMM, setSelMM] = useState("");
  const [selMonth, setSelmonth] = useState("");
  const [months, setMonths] = useState(new Map());
  let location = useLocation();

  const refresh = () => {
    getData("cmplm")
      .then((res) => {
        let dbdata = JSON.parse(res.data).mmmonths;
        let organizedmmmonths = monthsByMM(dbdata);
        setMMdata(organizedmmmonths);
      })
      .catch((err) => console.log(err));
  };

  const getCompData = (my_mm, month) => {
    getComplianceData(my_mm, month)
      .then((res) => {
        // first we create a map by product
        let compData = compByProduct(res.data);

        setComData(compData);
        setOrigComData(structuredClone(compData));
        setEditComData(new Map());
      })
      .catch((err) => console.log(err));
  };

  const compareMaps = (original, currentData, changedData) => {
    const result = [];
    changedData.forEach((val, key) => {
      new Set(val).forEach((_v, k) => {
        let oriRow = original.get(key).find((x) => x.dtime === k);
        let nuRow = currentData.get(key).find((x) => x.dtime === k);
        if (oriRow && nuRow) {
          if (
            Object.keys(nuRow).some(
              (rowCol) => nuRow[rowCol] !== oriRow[rowCol]
            )
          ) {
            result.push(nuRow);
          }
        }
      });
    });

    return result;
  };

  const saveChanges = () => {
    let valueUpdater = compareMaps(origComData, comData, editedComData);
    if (valueUpdater.length > 0) {
      setUpdating(
        `Actualizando valores de cumplimiento a las ${moment().format(
          "HH:mm:SS"
        )}.`
      );
      setComplianceData(valueUpdater)
        .then((response) => {
          setUpdating(
            `Respuesta recibida a las ${moment().format("HH:mm:SS")}:\n${
              response.data
            }`
          );
          refresh();
        })
        .catch((error) => {
          console.log(
            error,
            error?.response?.data ? error?.response?.data : ""
          );
          setUpdating(
            `Error recibido a las ${moment().format(
              "HH:mm:SS"
            )} mientras se actualizaba:\n${error}${
              error?.response?.data
                ? `\nDetalle del error:${error?.response?.data}`
                : ""
            }`
          );
          // refresh();
        });
    } else {
      setUpdating("Nada que actualizar");
    }
  };

  const handleEjecutarCumplimiento = () => {
    runMMCompliance(selMM, months.get(selMonth))
      .then((response) => {
        setUpdating(
          `Ejecución de cumplimiento de ${selMM} para ${months.get(
            selMonth
          )} finalizado a las ${response.data.time}.\nEstado final: ${
            response.data.state === "success" ? "éxito" : "error"
          }.${
            response?.data?.returnvalue
              ? "\nRespuesta recibida: " + response?.data?.returnvalue + "."
              : ""
          }`
        );
      })
      .catch((error) => {
        console.log(error);
      });
    setUpdating(
      `Ejecución de cumplimiento de ${selMM} para ${months.get(
        selMonth
      )} iniciado a las ${moment().format("HH:mm:SS")}.`
    );
  };

  const handleGenerarInformes = () => {
    console.log(moment().format("HH:mm:SS"));
    runMMComplReport(selMM, months.get(selMonth))
      .then((response) => {
        setUpdating(
          `Generación de informes de cumplimiento de ${selMM} para ${months.get(
            selMonth
          )} finalizada a las ${response.data.time}.\nEstado final: ${
            response.data.state === "success" ? "éxito" : "error"
          }.${
            response?.data?.returnvalue
              ? "\nRespuesta recibida: " + response?.data?.returnvalue + "."
              : ""
          }`
        );
      })
      .catch((error) => {
        console.log(error);
      });
    setUpdating(
      `Generando informes de cumplimiento de ${selMM} para ${months.get(
        selMonth
      )} iniciada a las ${moment().format("HH:mm:SS")}.`
    );
  };

  const handleGenerarSpreads = () => {
    console.log(moment().format("HH:mm:SS"));
    runMMComplSpreads(selMM, months.get(selMonth))
      .then((response) => {
        setUpdating(
          `Generación de spreads de ${selMM} para ${months.get(
            selMonth
          )} finalizada a las ${response.data.time}.\nEstado final: ${
            response.data.state === "success" ? "éxito" : "error"
          }.${
            response?.data?.returnvalue
              ? "\nRespuesta recibida: " + response?.data?.returnvalue + "."
              : ""
          }`
        );
      })
      .catch((error) => {
        console.log(error);
      });
    setUpdating(
      `Generando spreads de cumplimiento de ${selMM} para ${months.get(
        selMonth
      )} iniciada a las ${moment().format("HH:mm:SS")}.`
    );
  };

  const handleProcessRowUpdateError = React.useCallback((error) => {
    console.log(error.message);
  }, []);

  const processRowUpdate = React.useCallback(
    (key, newRow) => {
      let rows = [...comData.get(key)];

      let idx = rows.findIndex((obj) => obj?.dtime === newRow.dtime);
      rows[idx] = newRow;
      const nextComData = new Map(comData);
      nextComData.set(key, rows);
      setComData(nextComData);

      const nextEditedComData = new Map(editedComData);
      if (!nextEditedComData.has(key)) {
        nextEditedComData.set(key, []);
      }
      nextEditedComData.get(key).push(newRow.dtime);
      setEditComData(nextEditedComData);

      return newRow;
    },

    [comData, editedComData]
  );

  useEffect(() => {
    refresh();
  }, [location]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>
          <h3>Informe de Cumplimiento</h3>
        </div>

        <div className={styles.buttonGroup}>
          <LinkedDropdowns
            selMM={selMM}
            months={months}
            mmdata={mmdata}
            setSelMM={setSelMM}
            setMonths={setMonths}
            selMonth={selMonth}
            setSelmonth={setSelmonth}
            getCompData={getCompData}
            setComData={setComData}
            setOrigComData={setOrigComData}
          />
          <div className={styles.actionButtons}>
            <Button
              variant="outline"
              disabled={!selMonth}
              onClick={() => handleGenerarSpreads()}
              style={{ borderColor: "#c084fc" }}
            >
              Generar Spreads
            </Button>

            <Button
              variant="outline"
              disabled={!selMonth}
              onClick={() => handleEjecutarCumplimiento()}
              style={{ borderColor: "#a78bfa" }}
            >
              Ejecutar Cumplimiento
            </Button>

            <Button
              variant="outline"
              disabled={!selMonth}
              onClick={() => saveChanges()}
              style={{ borderColor: "#818cf8" }}
            >
              Guardar Cambios
            </Button>

            <Button
              variant="outline"
              disabled={!selMonth}
              onClick={() => handleGenerarInformes()}
              style={{ borderColor: "#60a5fa" }}
            >
              Generar Informes
            </Button>
          </div>
        </div>

        <pre
          className={`${styles.statusMessage} ${updating ? styles.statusMessageActive : ""}`}
        >
          {updating}
        </pre>
      </div>
      <div className={styles.tableContainer}>
        {comData.size === 0 ? (
          <p className={styles.noDataMessage}>
            No hay datos disponibles. Por favor, selecciona un Market Maker y un
            mes.
          </p>
        ) : (
          [...comData.entries()].map(([key, val]) => (
            <div key={key} className={styles.tableWrapper}>
              <p className={styles.productSection}>
                {key} - {selMonth}
              </p>
              <ThemeProvider theme={theme}>
                <DataGrid
                  getRowId={(row) => `${row.product}_${row.dtime}`}
                  processRowUpdate={(e) => processRowUpdate(key, e)}
                  onProcessRowUpdateError={handleProcessRowUpdateError}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? ""
                      : styles.dataGridRowAlt
                  }
                  rows={val}
                  columns={MI_COLUMNS}
                  columnGroupingModel={COLUMN_GROUPING_MODEL}
                  hideFooterPagination
                  hideFooterSelectedRowCount
                  hideFooter
                  sx={{
                    maxHeight: "500px",
                    width: "100%",
                    border: "none",
                    columnHeaderTitle: {
                      textAlign: "center",
                      headerAlign: "center",
                    },
                    "& .MuiDataGrid-columnHeader": {
                      backgroundColor: "hsl(var(--secondary))",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      whiteSpace: "normal",
                      lineHeight: "normal",
                      textAlign: "center",
                      fontWeight: 600,
                      color: "hsl(var(--muted-foreground))",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      overflowY: "auto",
                      maxHeight: "80vh",
                      backgroundColor: "hsl(var(--secondary))",
                    },
                  }}
                />
              </ThemeProvider>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ComplianceReport;
